module.exports = __webpack_public_path__ + "img/error.6d8e8a75.png";